import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { PopoverController, NavParams, NavController } from '@ionic/angular';

@Component({
  selector: 'app-menu-responsive',
  templateUrl: './menu-responsive.component.html',
  styleUrls: ['./menu-responsive.component.scss'],
})
export class MenuResponsiveComponent implements OnInit {

  //#region Propiedades

  public _utmCampaign: string = null;
  public _utmContent: string = null;
  public _utmMedium: string = null;
  public _utmSource: string = null;
  public _utmTerm: string = null;

  //#endregion Propiedades

  //#region Constructor

  constructor(private _route: ActivatedRoute,
              private _router: Router,
              public _navCtrl: NavController,
              public _popoverCtrl: PopoverController) { }

  //#endregion Constructor

  //#region Eventos NG

  public ngOnInit() { }

  public async ionViewDidEnter() {
    // registra visita
    await this._route.queryParams.subscribe((params) => {

      // recupera datos de UTM
      if (params['utm_campaign'] !== undefined) { this._utmCampaign = params['utm_campaign']; }
      if (params['utm_content'] !== undefined) { this._utmContent = params['utm_content']; }
      if (params['utm_medium'] !== undefined) { this._utmMedium = params['utm_medium']; }
      if (params['utm_source'] !== undefined) { this._utmSource = params['utm_source']; }
      if (params['utm_term'] !== undefined) { this._utmTerm = params['utm_term']; }
    });
  }

  //#endregion

  //#region Eventos Botones

  public btnFavoritos() {

    const navExtras: NavigationExtras = {
      queryParams: {
        f: 1,
      }
    };

    this._router.navigateByUrl('/blank', {skipLocationChange: true}).then(() => {
      this._router.navigate(['/categoriaDetalle'], navExtras);
    });

  }

  public closePopup() {
    this._popoverCtrl.dismiss();
  }

  //#endregion Eventos Botones

}
